import React from 'react';
import cx from 'classnames';
import { Checkbox, CheckboxProps } from 'antd';

import styles from './LrvCheckbox.module.scss';

export interface LrvCheckboxProps extends CheckboxProps {
  theme?: 'dark' | 'light';
}

export const LrvCheckbox = (props: LrvCheckboxProps) => {
  const { className, theme = 'dark' } = props;
  const isDarkTheme = theme === 'dark';

  const lrvProps = {
    ...props,
    className: cx(isDarkTheme ? styles.darkCheckbox : styles.lightCheckbox, className),
  };

  return (
    <Checkbox {...lrvProps}>
    </Checkbox>
  );
};
